import { useEffect, useState } from 'react';

/** 키보드로 보이는 영역이 이만큼 이상 줄면 "키보드가 열렸다"로 본다 (주소창·툴바 변화는 무시) */
const KEYBOARD_THRESHOLD_PX = 120;

/**
 * 모바일 키보드가 열려 있으면 보이는 영역(visualViewport) 높이를, 아니면 null 을 준다.
 *
 * iOS(사파리·앱 웹뷰)는 키보드가 올라와도 레이아웃 높이를 줄이지 않고 화면 전체를 위로 밀어 입력창을 보인다.
 * 그래서 화면 높이 그대로인 바텀시트는 헤더와 위쪽 대화가 화면 밖으로 밀려난다. 시트 높이를 이 값에 맞추면
 * 밀어 올린 뒤의 보이는 영역과 시트가 정확히 겹쳐 헤더부터 입력창까지 보인다.
 */
const useKeyboardViewportHeight = (enabled: boolean): number | null => {
  const [height, setHeight] = useState<number | null>(null);

  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return undefined;
    const vv = window.visualViewport;
    if (!vv) return undefined;

    const update = () => {
      // innerHeight 는 WebKit 에서 visualViewport 와 같이 줄어 비교 기준이 못 된다 — 레이아웃 높이(clientHeight)와 비교
      const keyboardOpen =
        document.documentElement.clientHeight - vv.height >
        KEYBOARD_THRESHOLD_PX;
      setHeight(keyboardOpen ? Math.round(vv.height) : null);
    };

    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, [enabled]);

  return enabled ? height : null;
};

export default useKeyboardViewportHeight;
